export enum DocumentState {
  "New" = 0,
  "Create" = 10,
  "Train" = 20,
  "Online" = 30,
  "Error" = 100,
}
